export default __webpack_public_path__ + "static/media/flags.5bc53ca7.png";